export const getListingCurrentPrice = ({
  status,
  soldPrice,
  listPrice,
}: {
  status: string | null | undefined;
  soldPrice: number | null | undefined;
  listPrice: number | null | undefined;
}): number | null => {
  if (status && status.toLowerCase() === "sold" && soldPrice != null) {
    return soldPrice;
  }
  return listPrice ?? null;
};
